import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { AiSparkleIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { useEffect, useMemo, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { showAcknowledgementModal, MR_ONBOARDING_WIZARD, getNotetakerAccessStartedAction } from 'features/meeting_intelligence';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { useNotetakerFreeExperiment } from 'hooks/useNotetakerFreeExperiment';
const betaContainerCss = "b1ofnjiy";
const BetaContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(betaContainerCss, props.className)} />;
});
const betaContentsReenableCss = "bxmeftx";
const betaContentsCss = "b1wf95ls";
const BetaContents = forwardRef((props, ref) => {
  const {
    reenable,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(betaContentsCss, {
    [betaContentsReenableCss]: reenable
  }, props.className)} />;
});
const headerTextCss = "hstr0w7";
const HeaderText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerTextCss, props.className)} />;
});
const bodyTextCss = "b12nxo9j";
const BodyText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyTextCss, props.className)} />;
});
export const AiBetaBanner = ({
  userHasEnabledMiBefore,
  user
}) => {
  const dispatch = useDispatch();
  const track = useTrack();
  const {
    isInExperiment: isInNotetakerFreeExperiment
  } = useNotetakerFreeExperiment();
  const onboardingPath = '/app/ai_notetaker_wizard';
  const eventProperties = useMemo(() => ({
    cta_text: userHasEnabledMiBefore ? 're_enable_notetaker' : 'get_started',
    cta_key: 'ai_notetaker_meetings_panel_entry_point',
    cta_destination: 'ai_notetaker_setup_flow'
  }), [userHasEnabledMiBefore]);
  useEffect(() => {
    if (!user) return;
    track({
      name: TRACKING_EVENT_NAMES.CTA_SHOWN,
      entities: ['attribution', 'organization', 'user'],
      properties: eventProperties
    });
  }, [track, eventProperties, user]);
  if (!user) return null;
  const handleClick = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      entities: ['attribution', 'organization', 'user'],
      properties: {
        ...eventProperties,
        action: userHasEnabledMiBefore ? 're_enable_ai_notetaker' : getNotetakerAccessStartedAction(isInNotetakerFreeExperiment)
      }
    });
    if (isInNotetakerFreeExperiment) {
      dispatch(showAcknowledgementModal(MR_ONBOARDING_WIZARD.USER_TRIGGERED));
    } else {
      window.open(onboardingPath, '_self');
    }
  };
  const getButtonText = () => {
    if (userHasEnabledMiBefore) {
      return I18n.t('publisher.meeting_intelligence.beta.banner.reenable_button');
    }
    if (isInNotetakerFreeExperiment) {
      return I18n.t('publisher.billing.meeting_intelligence.get_notetaker');
    }
    return I18n.t('publisher.billing.meeting_intelligence.try_notetaker');
  };
  return <BetaContainer>
      <BetaContents reenable={userHasEnabledMiBefore}>
        {userHasEnabledMiBefore ? <>
            <HeaderText>{I18n.t('publisher.meeting_intelligence.beta.banner.reenable_header')}</HeaderText>
            <BodyText>{I18n.t('publisher.meeting_intelligence.beta.banner.reenable_body')}</BodyText>
          </> : <>
            <HeaderText>{I18n.t('publisher.meeting_intelligence.beta.banner.header')}</HeaderText>
            <BodyText>{I18n.t('publisher.meeting_intelligence.beta.banner.body')}</BodyText>
          </>}
      </BetaContents>
      {!user?.is_pretending && <Button decoration="meeting-intelligence" onClick={handleClick}>
          <AiSparkleIcon />
          {getButtonText()}
        </Button>}
    </BetaContainer>;
};

require("./ai_beta_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ai_beta_banner.js");